import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";
import {
  fontWeightBold,
  h3Regular,
} from "../../../../components/typography/MuiTypography.style";

export const CreateActivityWrapper = styled.div`
  .MuiTabs-flexContainer {
    border-bottom: 5px solid ${COLORS.cirrus_black3};
  }

  .MuiGrid2-container {
    padding-right: 0px;
  }
  .activity-tab-general,
  .activity-tab-default {
    padding: 24px 0px 16px 16px;
    ${responsive.MOBILE`
      padding: 16px;
      .MuiGrid2-root:not(:first-child) {
        margin-top: 16px;
      }
    `}
  }

  .activity-tab-general {
    ${responsive.MOBILE`
      .MuiGrid2-root:not(:first-child) {
        margin-top: 16px;
      }
    `}
  }

  .exception-heading,
  .select-applicable {
    color: ${COLORS.cirrus_black10};
    border-top: 1px dotted ${COLORS.primary_light_blue4};
    margin-top: 24px;
    padding: 24px 16px 0px;
    ${responsive.MOBILE`
      margin-top: 0px;
      padding: 16px 16px 0 16px;
    `}
  }

  .checkbox-container {
    padding: 24px 16px;
    ${responsive.MOBILE`
      padding: 16px;
    `}
  }

  .topic-name {
    background-color: ${COLORS.cirrus_white};
    position: relative;
  }

  .topic-manage-locale-link {
    ${h3Regular}
    ${fontWeightBold}
    position: absolute;
    top: 0px;
    text-decoration: underline;
    text-underline-offset: 4px;
    right: 0px;
    color: ${COLORS.primary_light_blue};
  }

  .exception-form-container {
    padding: 24px 16px;

    .exception-form-field {
      padding-right: 16px;
      ${responsive.MOBILE`
        padding-right:0;
      `}
    }

    ${responsive.MOBILE`
    .MuiGrid2-root:not(:first-child) {
        margin-top: 16px;
      }
      padding: 16px;
    `}

    .MuiGrid2-root:has(.add-button) {
      ${responsive.MOBILE`
        width: 100%;
      `}
    }

    .add-button {
      margin-top: 30px;

      ${responsive.MOBILE`
        margin-top: 0;
        width: 100% !important;
      `}
    }
  }

  .table-container {
    padding: 24px 16px;
  }
`;
